var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9263 7.38535C13.7742 6.04854 12.6105 5.61982 11.1489 5.51744L11.1164 3.66005L9.98584 3.6799L10.0175 5.48834C9.72027 5.49356 9.41656 5.50474 9.11483 5.51603L9.08322 3.69562L7.95325 3.71531L7.98524 5.57217C7.74056 5.58144 7.50026 5.59019 7.26587 5.59443L7.26562 5.58868L5.70627 5.61536L5.72764 6.82285C5.72764 6.82285 6.56225 6.79236 6.54864 6.80798C7.00659 6.80012 7.16027 7.06338 7.20763 7.29204L7.24467 9.40799C7.27627 9.40761 7.31752 9.4082 7.36431 9.41378C7.32664 9.41449 7.28632 9.41494 7.24488 9.41602L7.29634 12.3803C7.27875 12.5247 7.19805 12.756 6.87811 12.7622C6.8928 12.7747 6.05626 12.7763 6.05626 12.7763L5.8552 14.1304L7.32648 14.1047C7.60028 14.1002 7.86976 14.1001 8.13427 14.0972L8.16753 15.9757L9.2969 15.9562L9.26442 14.0975C9.57462 14.0985 9.87476 14.0958 10.1677 14.0904L10.1995 15.9405L11.3301 15.9206L11.2977 14.0454C13.1965 13.9032 14.5185 13.4011 14.6526 11.6133C14.7608 10.1738 14.0736 9.54425 12.9901 9.30398C13.6397 8.95876 14.0393 8.36351 13.9263 7.38535ZM12.4147 11.4297C12.4398 12.8335 10.0333 12.7158 9.26711 12.7299L9.22395 10.241C9.9904 10.2278 12.3893 9.96547 12.4147 11.4297ZM11.8276 7.92732C11.8495 9.20454 9.84225 9.09049 9.20403 9.10168L9.16469 6.84432C9.80291 6.83313 11.8042 6.59517 11.8276 7.92732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcToken);
export default __webpack_public_path__ + "static/media/BTC-token.49f28f200aec8788e9a051ade26f1f2b.svg";
export { ForwardRef as ReactComponent };